'use client';
/* Built In Imports */
/* External Imports */
import { Box, Skeleton } from '@chakra-ui/react';
import forEach from 'lodash/forEach';
import { nanoid } from 'nanoid';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import Slider from 'react-slick';
/* Internal Imports */
/* Components */
import SliderEmbed from '@app-ps/Components/Embeds/SliderEmbed';

/* Services */
/* Styles */
import { useState } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 * Renders the MultimediaSlider component
 *
 * @param {object} sectionContent - Data for section
 * @returns {ReactElement} MultimediaSlider component
 */
const MultimediaSlider = ({ sectionContent }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const NextArrow = props => {
    const { onClick } = props;
    return (
      <Box
        as="button"
        onClick={onClick}
        position="absolute"
        bottom={{ base: '-18.5%', lg: '-9%' }}
        // right={{ base: '39%', lg: '46.5%' }}
        right="calc(50% - 42px)"
        zIndex={1000}
        bgColor="#F1EDE91A"
        // width="6rem"
        // height="3rem"
        bgPosition="center"
        borderRadius="0px 16px 16px 0px"
        bgSize="cover"
        boxSize="2.5rem"
        overflow="visible"
        display={{ base: 'flex' }}
        alignItems="center"
        justifyContent="center"
        color="#FEFAF6"
        fontSize="1rem"
        cursor="pointer"
        padding="0"
      >
        <IoIosArrowForward fontSize="2rem" />
      </Box>
    );
  };

  const PrevArrow = props => {
    const { onClick } = props;
    return (
      <Box
        as="button"
        onClick={onClick}
        position="absolute"
        bottom={{ base: '-18.5%', lg: '-9%' }}
        borderRadius="16px 0px 0px 16px"
        bgPosition="center"
        bgSize="cover"
        // right={{ base: '50%', '2xl': '49%' }}
        left="calc(50% - 42px)"
        zIndex={1000}
        bgColor="#F1EDE91A"
        boxSize="2.5rem"
        overflow="visible"
        display={{ base: 'flex' }}
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        fontSize="1rem"
        padding="0"
        color="#FEFAF6"
      >
        <IoIosArrowBack fontSize="2rem" />
      </Box>
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    // fade: true,
    waitForAnimate: true,
    centerPadding: '25px',
    slidesToScroll: 1,
    className: 'multimedia_slider',
    variableWidth: true,
    afterChange: function (index) {
      setActiveIndex(index);
    },
    speed: 500,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1480,
        settings: {
          dots: false,
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: '15px',
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          dots: false,
          centerPadding: 0,
          infinite: true,
          centerMode: false,
          variableWidth: false,
        },
      },
    ],
  };

  let slides = [];

  if (sectionContent?.videoUrl) {
    slides.push({
      type: 'video',
      videoUrl: sectionContent?.videoUrl,
    });
  }
  if (sectionContent?.images?.length) {
    forEach(sectionContent?.images, function (image) {
      // console.log('slides', image)
      slides.push({
        type: 'image',
        imgUrl: image?.image?.url,
      });
    });
  }
  return (
    <Box
      w="100%"
      maxW="100%"
      overflow="hidden"
      bg="#0E1216"
      pt={{
        base: '6',
        lg: '1rem',
      }}
      boxSizing="border-box"
      pb={{
        base: '5rem',
        md: '10rem',
        lg: '18rem',
      }}
    >
      <Box height="100%">
        <Slider
          {...settings}
          sx={{
            '.slick-slider.multimedia_slider .slick-track': {
              maxHeight: 600,
            },
            '.multimedia_slider .slick-slide>div': {
              transition: 'filter .3s cubic-bezier(.4, 0, .2, 1)',
            },
          }}
        >
          {slides.map((slide, index) => {
            return (
              <Box
                key={nanoid()}
                maxW={{ base: '100%', md: '973px' }}
                maxH={{ base: '100%', md: '563px' }}
                width={{ base: '100%', lg: '970px !important' }}
                height={{
                  base: '205px',
                  sm: '320px',
                  md: '410px',
                  lg: '600px',
                }}
                // padding={{
                //   base: '0',
                //   md: activeIndex === index ? '0 13.5px' : '20px 12.5px',
                // }}
                // transition="all 0.2s ease"
              >
                <Skeleton
                  isLoaded={slide.videoUrl || slide.imgUrl}
                  fadeDuration={0.1}
                  width="100%"
                  height="100%"
                  bg="gray.500"
                >
                  <Box
                    bgImage={slide?.imgUrl}
                    bgSize="cover"
                    width="100%"
                    height="100%"
                    bgPos="center"
                    // filter={activeIndex === index ? "grayscale(0%)" : "grayscale(80%)"}
                    className="multimediaSlide"
                    // transition="all 0.4s ease"
                  >
                    {slide?.videoUrl && (
                      <SliderEmbed
                        height={'100%'}
                        width="100%"
                        sectionContent={{
                          embedUrl: slide?.videoUrl,
                        }}
                        margin={0}
                      />
                    )}
                  </Box>
                </Skeleton>
              </Box>
            );
          })}
        </Slider>
        <style>
          {`
              .multimedia_slider .slick-slide>div {
                  transform: scale(.95);
                  transition: all .3s cubic-bezier(.0, 0, .0, 1);
                  filter: grayscale(80%);
              }

              .multimedia_slider .slick-center>div, .multimedia_slider .slick-current>div {
                  transform: scale(1) !important;
                  filter:grayscale(0%);
                  transition: all .3s cubic-bezier(.0, 0, .0, 1) !important;
              }
          `}
        </style>
        {/* '0 13.5px' : '20px 12.5px' */}
      </Box>
    </Box>
  );
};

export default MultimediaSlider;
